/**
 * <ClassItem 
 *		// please describe props here
 *	/>
 *
 * - When there is a nesting tr, we use tbody as a row.
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React from 'react';
import classnames from 'classnames'
import ProfileBadge from 'components/UI/ProfileBadge'
import Loading from 'components/UI/Loading';

class ClassItem extends React.Component {

  constructor(props) {
    super(props);
    this.handleLessonScrolling = this.handleLessonScrolling.bind(this);
  }

  handleLessonScrolling(){
    const { loadMoreLessons, isloadingMoreLesson } = this.props;
    let bottomOffset = 400;
    if(this.lessonLoadingScroller && !isloadingMoreLesson && (this.lessonLoadingScroller.scrollTop >= this.lessonLoadingScroller.scrollHeight-bottomOffset)){
      loadMoreLessons();
    }
  }
  render() {
    const {
      cls, 
      enrolled,
      selected,
      onSelectClass,
      loadingLessons,
    } = this.props;

    const { teacherList } = cls;

    const profiles = teacherList.map((teacher)=>{
      return {
        name: teacher.stName,
      }
    });

    return (
      <div className='select-class-item'>
        { loadingLessons == true && selected && <Loading zoom={0.7} /> }
        { loadingLessons == true && selected && <div className='loadingMask'></div> }
        <div className={classnames('select-class', { selected, })} onClick={onSelectClass}>
          <div>
            <h5>{cls.className}</h5>
          </div>
          <div style={{ float: 'left' }}> 
            <small>{__('Date', 'class')}: {cls.earliest_date} - {cls.latest_date}</small>            
            <small>{__('Student: {number}', 'schedule', { number: cls.studentCount })}</small>            
          </div>
          <div style={{ float: 'left' }}> 
            <small>{__('Teacher', 'teacher')}: </small>
            { teacherList.length === 0 && <small>{__('N/A', 'data')}</small> }
            { profiles.length > 0 && <div style={{float: 'left'}}><ProfileBadge profiles={profiles} /></div> }
          </div>
          <div className={classnames('select-button', { enrolled })}>
            <i className='fa icon-right-open right-arrow'></i>
          </div>
        </div>
      </div>
     );
  }
}

export default ClassItem;



// WEBPACK FOOTER //
// ./src/template/Modals/EnrollClass/ClassItem.js